import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

import { authenticateImpersonationToken } from "@api/auth/authenticateImpersonationToken";
import { authenticateOrganization } from "@api/auth/authenticateOrganization";
import { createOrganizationFromDiscovery } from "@api/auth/createOrganizationFromDiscovery";
import { logout } from "@api/auth/logout";
import { requestOauthToken } from "@api/auth/requestOauthToken";
import { validateDiscoveryToken } from "@api/auth/validateDiscoveryToken";

export const useAuth = () => {
  const queryClient = useQueryClient();

  const requestOauthTokenMutation = useMutation({
    mutationFn: requestOauthToken,
  });

  const validateDiscoveryTokenMutation = useMutation({
    mutationFn: validateDiscoveryToken,
  });

  const createOrganizationFromDiscoveryMutation = useMutation({
    mutationFn: createOrganizationFromDiscovery,
  });

  const authenticateOrganizationMutation = useMutation({
    mutationFn: authenticateOrganization,
  });

  const authenticateImpersonationTokenMutation = useMutation({
    mutationFn: authenticateImpersonationToken,
  });

  const logoutMutation = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.clear();
    },
  });

  return useMemo(
    () => ({
      requestOauthTokenMutation,
      validateDiscoveryTokenMutation,
      createOrganizationFromDiscoveryMutation,
      authenticateOrganizationMutation,
      authenticateImpersonationTokenMutation,
      logoutMutation,
    }),
    [
      requestOauthTokenMutation,
      validateDiscoveryTokenMutation,
      createOrganizationFromDiscoveryMutation,
      authenticateOrganizationMutation,
      authenticateImpersonationTokenMutation,
      logoutMutation,
    ],
  );
};
